exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bL9fHJhbkB7QhlSAWspIr {\n    display: flex;\n    gap: 20px;\n}", ""]);

// exports
exports.locals = {
	"root": "bL9fHJhbkB7QhlSAWspIr"
};